import {
  DOWNLOAD_CLIP_REQUEST,
  DOWNLOAD_CLIP_SUCCESS,
  DOWNLOAD_CLIP_FAILURE,
  FETCH_CLIP_REQUEST,
  FETCH_CLIP_FAILURE,
  FETCH_CLIP_SUCCESS
} from '../actions/ClipActions'

const initialState = {
  loading: false,
  requestingDownload: false,
  clips: {}
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_CLIP_REQUEST:
      return {
        ...state,
        requestingDownload: true
      }
    case DOWNLOAD_CLIP_SUCCESS:
    case DOWNLOAD_CLIP_FAILURE:
      return {
        ...state,
        requestingDownload: false
      }
    case FETCH_CLIP_REQUEST:
      return {
        ...state,
        loading: true,
        errors: null
      }
    case FETCH_CLIP_SUCCESS:
      return {
        ...state,
        loading: false,
        clips: {
          [action.data.id]: action.data
        }
      }
    case FETCH_CLIP_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ../src/reducers/clips.js